import { IcoGripperHorizontal } from '@components/icons';
import { RuzcalFormQuestion } from './types';

export function RuzcalFormReadOnlyQuestion({
  question,
  onClick,
}: {
  question: RuzcalFormQuestion;
  showScore?: boolean;
  hideRequiredChar?: boolean;
  onClick: () => void;
}) {
  return (
    <div
      class="flex flex-col gap-4 p-6 py-4 border rounded-md mb-4 group relative"
      onClick={onClick}
    >
      <div
        class="absolute inset-x-9 top-0 flex justify-center invisible group-hover:visible text-gray-400 cursor-move"
        draggable
      >
        <IcoGripperHorizontal class="w-5 h-5" />
      </div>
      <p class="text-lg whitespace-pre-line">{question.title || 'Question'}</p>
    </div>
  );
}
